import Forms from './../Forms';
import LazyLoad from './../../library/LazyLoad';

export default class Filters {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Filters;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on('fieldChange', '.js-shop-filters-form', function() {
			self.filterProducts($(this));
		});

		$(document).on('change', '.js-shop-filters-form input[type="checkbox"]', function() {
			$(this).parents('.js-shop-filters-form').trigger('fieldChange');
		});

		$(document).on('change', 'select.js-shop-sort', function() {
			self.filterProducts($(this).parents('.js-shop-sort-form'));
		});

		$(document).on('click', '.js-shop-pagination', function(e) {
			e.preventDefault();
			let page = $(this).data('page'),
				$form = $('.js-shop-sort-form');

			$form.find('input[name="pageNumber"]').val(page);

			self.productsChangePage($form);
		});

		$(document).on('click', '.js-expand-filter-options', function(e) {
			e.preventDefault();
			self.toggleFilterOptions($(this));
		});







		$(document).on('click', '.js-clear-filter', function(e) {
			e.preventDefault();
			self.clearOrderFilterOptions($(this));
		});
	}

	load() {
		const self = this;

		oc.progressBar.show();

		oc.ajax('shopProducts::onLoadFilters', {
			update: {'shopProducts/filters': '.js-shop-filters'},
			success: function(data, responseCode, xhr) {
	            this.success(data, responseCode, xhr);

	            oc.progressBar.hide();

	            Forms.setResolutionInputs();
				Forms.initSelectPlugin($('.js-shop-filters .js-select2'));
				Forms.initRangeSlider($('.js-shop-filters .js-range-slider'));

				let order = $('.js-shop-sort-form').find('select[name="sortOrder"]').val();
				$('.js-shop-filters input[name="sortOrder"]').val(order);
	        }
		});
	}

	updateUrl($form) {
		const self = this;
		let queryString = '';

		if ($form) {
			let $rangeSlider = $form.find('.js-range-slider'),
				rangeSliderData = ($rangeSlider.length > 0 ? $rangeSlider.data('range-options') : false),
				minPrice = rangeSliderData ? rangeSliderData.min : false,
				maxPrice = rangeSliderData ? rangeSliderData.max : false,
				minPriceSelected = $form.find('input[name="minPrice"]').val(),
				maxPriceSelected = $form.find('input[name="maxPrice"]').val(),
				formData = $form.serializeArray();

			// create query string and unset prices if they are the same as min & max values
			for(var i = 0; i < formData.length; i++) {
				if (formData[i].name == 'minPrice' && minPrice == minPriceSelected) {
					delete formData[i];
				} else if (formData[i].name == 'maxPrice' && maxPrice == maxPriceSelected) {
					delete formData[i];
				} else if (formData[i].name == 'pageNumber' && formData[i].value == 1) {
					delete formData[i];
				} else if (formData[i].name == 'sortOrder' && formData[i].value == 'created_at-desc') {
					delete formData[i];
				} else {
					queryString += (queryString == '' ? '?' : '&');
					queryString += formData[i].name + '=' + formData[i].value;
				}
			}
		}

		let cleanUrl = window.location.href.split('?')[0],
			updatedUrl = cleanUrl + queryString;

		// update url with new query string
		if (typeof (history.pushState) != "undefined") {
			history.pushState(null, null, updatedUrl);
		}
	}

	productsChangePage($form) {
		const self = this;

		self.updateUrl($form);

		oc.progressBar.show();

		oc.ajax('shopProducts::onSearch', {
			update: {
				'shopProducts/controls': '.js-shop-sort',
				'shopProducts/default': '.js-shop-products',
			},
			success: function(data, responseCode, xhr) {
	            this.success(data, responseCode, xhr);

	            oc.progressBar.hide();

	            Forms.setResolutionInputs();
				Forms.initSelectPlugin($('.js-shop-sort .js-select2'));

				// Force load all lazy images and SVGs immediately after pagination
				setTimeout(function() {
					console.log('Pagination: Looking for lazy elements...');
					const lazyImages = document.querySelectorAll('.js-shop-products [data-lazy-img]');
					const lazySvgs = document.querySelectorAll('.js-shop-products [data-lazy-svg]');
					console.log('Pagination: Found', lazyImages.length, 'images and', lazySvgs.length, 'SVGs');

					// Remove is-lazy-observed class from new elements
					lazyImages.forEach(img => img.classList.remove('is-lazy-observed'));
					lazySvgs.forEach(svg => svg.classList.remove('is-lazy-observed'));

					// Force load them immediately
					const lazyload = new LazyLoad();
					lazyImages.forEach(img => lazyload.preloadImage(img));
					lazySvgs.forEach(svg => lazyload.preloadSvg(svg));
					console.log('Pagination: Force loaded lazy elements');
				}, 50);

				$('html, body').animate({
					scrollTop: $('.js-shop-sort').offset().top - 15
                }, 400);
	        }
		});
	}


	filterProducts($form) {
		const self = this;

		self.updateUrl($form);

		oc.progressBar.show();

		oc.ajax('shopProducts::onLoadFilters', {
			update: {
				'shopProducts/filters': '.js-shop-filters',
				'shopProducts/controls': '.js-shop-sort',
				'shopProducts/default': '.js-shop-products',
			},
			success: function(data, responseCode, xhr) {
	            this.success(data, responseCode, xhr);

				if (data && data['shopProducts/filters']) {
					$('.js-shop-filters').html(data['shopProducts/filters']);
				}

	            oc.progressBar.hide();

	            Forms.setResolutionInputs();
				Forms.initSelectPlugin($('.js-shop-filters .js-select2'));
				Forms.initSelectPlugin($('.js-shop-sort .js-select2'));
				Forms.initRangeSlider($('.js-shop-filters .js-range-slider'));
				LazyLoad.watchNewElement('.js-shop-products [data-lazy-img]');
				LazyLoad.watchNewElement('.js-shop-products [data-lazy-svg]');
	        }
		});
	}

	toggleFilterOptions($link) {
		const self = this;

		let $options = $link.next('.filter-options');

		if ($options.is(':visible')) {
			$options.slideUp(200);
			$link.removeClass('is-expanded');
		} else {
			$options.slideDown(200);
			$link.addClass('is-expanded');
		}
	}


	clearOrderFilterOptions() {
		const clearFilterLink = document.querySelector('.js-clear-filter');
		const dropdown = document.getElementById('filterOrderTypes');
		const sortDropdown = document.getElementById('filterOrderSort');
		dropdown.value = 'All';
		if (sortDropdown) {
			sortDropdown.value = 'desc';
		}
		const event = new Event('change', { bubbles: true });
		dropdown.dispatchEvent(event);
	}
};

